<template>
  <div class="application-card">
    <div class="application-card--header">
      <div class="application-card--media">
        <img
          v-if="integrationLogo"
          :src="`/dashboard/images/integrations/${integrationLogo}`"
          :alt="integrationName"
        />
        <fluent-icon v-else :icon="integrationIcon" size="24" />
      </div>
      <h3 class="application-card--title">
        {{ integrationName }}
      </h3>
    </div>
    <p class="application-card--description">
      {{ integrationDescription }}
    </p>
    <div class="application-card--footer">
      <router-link :to="integrationPath">
        <woot-button icon="settings">
          {{ $t('INTEGRATION_APPS.CONFIGURE') }}
        </woot-button>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    integrationId: {
      type: [String, Number],
      required: true,
    },
    integrationLogo: {
      type: String,
      default: '',
    },
    integrationIcon: {
      type: String,
      default: 'star-emphasis',
    },
    integrationName: {
      type: String,
      default: '',
    },
    integrationDescription: {
      type: String,
      default: '',
    },
    integrationPath: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.application-card {
  background: var(--white);
  border: 1px solid var(--s-75);
  border-radius: var(--border-radius-normal);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  padding: var(--space-normal);
}

.application-card--header {
  align-items: center;
  display: flex;
  gap: var(--space-small);
  margin-bottom: var(--space-small);
}

.application-card--media {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: var(--space-medium);
  justify-content: center;
  width: var(--space-medium);

  img {
    max-height: 100%;
    max-width: 100%;
  }
}

.application-card--title {
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-medium);
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}

.application-card--description {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  color: var(--s-600);
  display: -webkit-box;
  flex: 1;
  font-size: var(--font-size-small);
  margin-bottom: var(--space-normal);
  overflow: hidden;
}

.application-card--footer {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}
</style>
